import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Process from "./components/Process";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ForDoctors from "./components/ForDoctors";
// import Team from "./components/Team";
import More from "./components/More";
// import Work from "./components/work";
// import ServiceDetails from "./components/serviceDetails";
// import Pricing from "./components/Pricing";
import FAQs from "./components/FAQs";
// import Media from "./components/Media";
import Blog from "./components/Blog";
import BlogDetails from "./components/BlogDetails";
import OurServices from "./components/OurServices";
// import Doctors from "./components/Doctors";
import YoutubeShorts from "./components/YoutubeShorts";
import InterviewCarousel from "./components/InterviewsCarousel";
import AltFAQ, { faqData } from "./components/FAQ2";
import Results from "./components/Results";
import Pricing from "./components/Pricing";

function App() {
  useEffect(() => {
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <div className="App">
      <>
        <Router>
          <Header />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Home />
                  <About />
                  <Services />
                  <Process />
                  <YoutubeShorts />
                  {/* <Team /> */}
                  <Reviews />
                  {/* <Work /> */}
                  <InterviewCarousel />
                  <AltFAQ faqData={faqData} />
                  <Contact />
                </>
              }
            />
            <Route path="/More" element={<More />} />
            {/* <Route path="/ServiceDetails" element={<ServiceDetails />} /> */}
            <Route path="/Pricing" element={<Pricing />} />
            <Route path="/Results" element={<Results />} />
            <Route path="/FAQs" element={<FAQs />} />
            {/* <Route path="/Media" element={<Media />} /> */}
            <Route path="/news" element={<Blog />} />
            <Route path="/OurServices" element={<OurServices />} />
            {/* <Route path="/Doctor" element={<Doctors />} /> */}
            <Route path="/blog/:id" element={<BlogDetails />} />
            <Route path="/for-doctors" element={<ForDoctors />} />
          </Routes>
          <Footer />
        </Router>
      </>
    </div>
  );
}

export default App;
